module.exports = __webpack_public_path__ + "img/phlebio-view-inactive.ee21678c.svg";